import { ComponentType, type IConfig } from '../../types';

export const config: IConfig = {
  component: ComponentType.SinglePage,
  configGroups: [
    {
      title: 'Component Styles',
      component: 'CssSettings',
    },
  ],
};
